var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomerDashboardThreeDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 31.002,
    width: 30,
    height: 30,
    rx: 15,
    transform: "rotate(-90 1 31.002)",
    stroke: "#212325"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 22.4186C14.1667 23.427 14.9917 24.252 16 24.252C17.0084 24.252 17.8334 23.427 17.8334 22.4186C17.8334 21.4103 17.0084 20.5853 16 20.5853C14.9917 20.5853 14.1667 21.4103 14.1667 22.4186Z",
    stroke: "#E1E1E1",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 9.58464C14.1667 10.593 14.9917 11.418 16 11.418C17.0084 11.418 17.8334 10.593 17.8334 9.58464C17.8334 8.5763 17.0084 7.7513 16 7.7513C14.9917 7.7513 14.1667 8.5763 14.1667 9.58464Z",
    stroke: "#E1E1E1",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 16.0026C14.1667 17.0109 14.9917 17.8359 16 17.8359C17.0084 17.8359 17.8334 17.0109 17.8334 16.0026C17.8334 14.9943 17.0084 14.1693 16 14.1693C14.9917 14.1693 14.1667 14.9943 14.1667 16.0026Z",
    stroke: "#E1E1E1",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerDashboardThreeDots);
export default __webpack_public_path__ + "static/media/customer_dashboard_three_dots.0450d6868b392730c58322efe3d32a10.svg";
export { ForwardRef as ReactComponent };